import { ModLevel } from '@/models/engineering-models.model';
import { computed, inject, Injectable, signal } from '@angular/core';
import { CacheLoaderService } from './cache-loader.service';

@Injectable({
  providedIn: 'root'
})
export class ModLevelsService {
    modLevels = signal<ModLevel[]>([]);
    selectedModLevel = signal<ModLevel | null>(null);

  constructor(
    private cacheLoader: CacheLoaderService<ModLevel>
  ) {
    this.loadModLevels();
   }

  loadModLevels(): void {
    this.cacheLoader.loadData('mods', (modLevels) => {
      this.modLevels.set(modLevels);
    }, 'modLevelsCacheKey');
  } 

  setSelectedModLevelById(modLevelId: number) {
    const modLevel = this.modLevels().find(m => m.ModID === modLevelId) || null;
    this.selectedModLevel.set(modLevel);
  }


}
